<template>
  <q-btn v-bind="$attrs">
    <slot></slot>
  </q-btn>
</template>
